import { UTC_TIME_ZONE, DEFAULT_TIMEZONE, DEFAULT_TIMEOFFSET } from './constants';
import timezones from './timezones.json';

export const createReducer = (schema, reducer) => (
  initialState = schema,
  action$
) => (reducer[action$.type] || (() => initialState))(initialState, action$);

export const dispatch = (type, payload) => ({ type, payload });

export const downloadBlobFile = (content, filename, contentType) => {
  var blob = new Blob([content], { type: contentType });
  var url = URL.createObjectURL(blob);

  var pom = document.createElement("a");
  pom.href = url;
  pom.setAttribute("download", filename);
  pom.click();
};

export const arrayToCsvFormat = (data, headers) => {
  const headerRow = headers.join(",");
  
  const rows = data.map(row => {
    return headers.map(header => {
      const fieldName = header.replace(/ /g, "_");
      const value = row[fieldName] !== undefined ? row[fieldName] : "";
      return `"${String(value).replace(/"/g, '""')}"`;
    }).join(",");
  });

  return [headerRow, ...rows].join("\r\n");
};

/**
 * Get the current API base URL based on selected version
 * @returns {string} The current API base URL
 */
export const getCurrentApiUrl = () => {
  const { getCurrentApiBaseUrl } = require('./constants');
  return getCurrentApiBaseUrl();
};

/**
 * Get the selected API version name
 * @returns {string} The selected API version name
 */
export const getSelectedApiVersion = () => {
  return localStorage.getItem('selected-api-version') || 'cardio_cloud';
};

export const isFdaViewEnabled = () => {
  return localStorage.getItem('fdaView') === 'true';
};

export const setFdaView = (enabled) => {
  localStorage.setItem('fdaView', enabled.toString());
};

export const roleMapping = (role) => {
  return {
    "tenantadmin": "Manufacturer Admin",
    "tenantuser": "Manufacturer User",
    "supplieradmin": "Company Admin",
    "supplieruser": "Company User",
    "practiceadmin": "Facility Admin",
    "practiceuser": "Facility User",
    "patient": "Care Team",
    "observe": "Guest",
  }[role.toLowerCase()];
};

export const roleBasedRolesList = (rolesList) => {
  const userDetails = JSON.parse(localStorage.getItem("user-details"));
  const role = userDetails !== null ? userDetails.roles[0].role : "";

  if(role === "TenantUser") {
    return rolesList.filter((val) => val.key !== "TenantAdmin" || val.key !== "all");
  } else if(role === "SupplierAdmin") {
    return rolesList.filter((val) => !["TenantAdmin", "TenantUser", "all"].includes(val.key));
  } else if(role === "SupplierUser") {
    return rolesList.filter((val) => !["TenantAdmin", "TenantUser", "all", "SupplierAdmin"].includes(val.key));
  } else if(role === "PracticeAdmin") {
    return rolesList.filter((val) => !["TenantAdmin", "TenantUser", "all", "SupplierAdmin", "SupplierUser"].includes(val.key));
  } else if(role === "PracticeUser") {
    return rolesList.filter((val) => !["TenantAdmin", "TenantUser", "all", "SupplierAdmin", "SupplierUser", "PracticeAdmin"].includes(val.key));
  } else if(role === "Patient") {
    return rolesList.filter((val) => !["TenantAdmin", "TenantUser", "all", "SupplierAdmin", "SupplierUser", "PracticeAdmin", "PracticeUser"].includes(val.key));
  } else if(role === "Guest") {
    return rolesList.filter((val) => !["TenantAdmin", "TenantUser", "all", "SupplierAdmin", "SupplierUser", "PracticeAdmin", "PracticeUser", "Patient"].includes(val.key));
  }
  return rolesList;
};

/**
 * Check if a query parameter exists in the current URL
 * @param {string} paramName - The name of the query parameter to check
 * @returns {boolean} True if the parameter exists, false otherwise
 */
export const hasQueryParam = (paramName) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.has(paramName);
};

export const getUserTimeZone = () => {
  const selectedZone = timezones.find((time) => time.value === UTC_TIME_ZONE) || {};
    selectedZone.offset = selectedZone.offset || DEFAULT_TIMEOFFSET;
    selectedZone.abbr = selectedZone.abbr || DEFAULT_TIMEZONE;
    if (!selectedZone.utc) {
      selectedZone.utc = timezones.find((time) => time.abbr === DEFAULT_TIMEZONE).utc;
    }
    return selectedZone;
};